import { lazyLoad } from '../../utils/loadable';
export var LoginPage = lazyLoad(function () { return import('./Login'); }, function (module) { return module.Login; });
